import cookie from "../../modules/cookie"
import delayparams from "../../modules/url/delayQuote"

// 分时K线图类型
export enum ChartType {
  "分时",
  "五日",
  "日K",
  "周K",
  "月K",
  "5分钟",
  "15分钟",
  "30分钟",
  "60分钟",
  "未知",
}

export enum StockMoreTabType {
  "盘口",
  "分时成交",
  "相关"
}

export enum RelevantType {
  "相关品种",
  "相关板块",
  "相关组合"
}

export enum QuotationType {
  "逐笔申报",
  "逐笔成交"
}

export enum TransactionType {
  "全部成交",
  "匹配成交",
  "点击成交",
  "询价成交",
  "协商成交",
  "意向申报",
  "竞买成交",
}

export enum DeclareDataType {
  "时间",
  "买卖方向",
  "价格",
  "数量",
  "交易方式",
  "结算方式",
  "结算周期",
  "交易商",
  "交易员",
  "未知" = 99,
}

export enum TransactionDataType {
  "时间",
  "成交价",
  "成交量",
  "交易方式",
  "结算方式",
  "结算周期",
  "未知" = 99,
}

export enum QuoteTradeRecord {
  "十档行情",
  "五档行情",
  "一档行情",
  "零档行情",
  "未知"
}

export function getCookie(a: string) {
  let c,
    d,
    b = document.cookie.split(";")
  for (c = 0; c < b.length; c++) if (((d = b[c].split("=")), d[0].replace(" ", "") == a)) return unescape(decodeURI(d[1]))
  return ""
}

export function formatNumToPercent(value: any, rate: number) {
  if (value == "-" || value == undefined || isNaN(value)) return value
  let num = Number(value)
  let r = Number(rate)
  let temp = Math.pow(10, r)
  if (num) {
    return (num / temp).toFixed(rate) + "%"
  } else {
    return num.toFixed(rate) + "%"
  }
}

export function formatNumToFixed(value: any, rate: number, prefix = "", suffix = "") {
  if (value == "-" || value == undefined || isNaN(value)) return value
  let num = Number(value)
  let r = Number(rate)
  let temp = Math.pow(10, r)

  if (num) {
    return prefix + (num / temp).toFixed(rate) + suffix
  } else {
    return prefix + num.toFixed(rate) + suffix
  }
}

export function formatUniqueNumToFixed(value: any, rate: number, tofixed: number, suffix = "") {
  if (value == "-" || value == undefined || isNaN(value)) return "-"
  let num = Number(value)
  let r = Number(rate)
  let temp = Math.pow(10, r)

  if (num) {
    return (num / temp).toFixed(tofixed) + suffix
  } else {
    return num.toFixed(tofixed) + suffix
  }
}

export function formatColor(value: any) {
  if (value == "-" || isNaN(Number(value)) || value == null) return ""

  if (value.toString().indexOf("-") > -1) {
    return "green"
  } else if (value == 0) {
    return "gray"
  } else {
    return "red"
  }
}

export function formatColor2(value: any) {
  if (value == "-" || isNaN(Number(value)) || value == null) return ""

  if (value.toString().indexOf("-") > -1) {
    return "green"
  } else if (value == 0) {
    return "black"
  } else {
    return "red"
  }
}

export function formatCompareColor(value: any, value1: any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
    return ""
  }

  if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
    return "gray"
  }

  if (parseFloat(value) > parseFloat(value1)) {
    return "red"
  } else if (parseFloat(value) < parseFloat(value1)) {
    return "green"
  } else if (parseFloat(value) == parseFloat(value1)) {
    return "black"
  } else {
    return ""
  }
}

export function formatTipsCompareColor(value: any, value1: any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
    return ""
  }

  if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
    return "gray"
  }

  if (parseFloat(value) < parseFloat(value1)) {
    return "red"
  } else if (parseFloat(value) > parseFloat(value1)) {
    return "green"
  } else if (parseFloat(value) == parseFloat(value1)) {
    return "black"
  } else {
    return ""
  }
}

export function formatHKTimeTradeColor(value: any, value1: any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
    return ""
  }

  if (parseFloat(value) > parseFloat(value1)) {
    return "red"
  } else if (parseFloat(value) < parseFloat(value1)) {
    return "green"
  } else if (parseFloat(value) == parseFloat(value1)) {
    return "black"
  } else {
    return ""
  }
}

export function formatStockColor(value: any, value1: any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
    return ""
  }

  if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
    return "gray"
  }

  if (parseFloat(value) > parseFloat(value1)) {
    return "red"
  } else if (parseFloat(value) < parseFloat(value1)) {
    return "green"
  } else {
    return ""
  }
}

export function formatSingleColor(value: any) {
  if (value == null || value == "-" || value == undefined) {
    return "";
  }
  return (value > 0 ? 'red' : (value < 0 ? 'green' : ''))
}

export function formatTipsSingleColor(value: any) {
  if (value == null || value == "-" || value == undefined) {
    return "";
  }
  return (value > 0 ? 'green' : (value < 0 ? 'red' : ''))
}

export function formatBondSingleColor(value: any) {
  if (value == null || value == "-") {
    return "";
  }
  return (Number(value) > 0 ? 'red' : ((Number(value) < 0) ? 'green' : 'gray'))
}

export function getProfit(value: any) {
  if (value == null || value == '-' || value == undefined) {
    return ""
  }
  let profitArr = ['一', '二', '三', '四', '五', '六', '七']
  return profitArr[Number(value - 1)]
}

export function formatUnit(value: any, unit: string, point?: any, singlenp?: number) {
  //singlenp:1个位数时不需要保留小数位
  if (value == null || value == "-" || value == "0" || value == undefined) {
    if (value != null && value != "-" && unit != "calc") {
      return value + unit
    } else {
      return value
    }
  }
  if (point == "" || point == null || point == undefined || point == "undefined") {
    point == 2
  }
  if (unit == "calc") {
    let temp = value
    if (temp < 10000) {
      if (Number(temp).toFixed(2) == "0.00") {
        return 0
      } else {
        if (singlenp == 1) {
          return temp
        } else {
          return Number(temp).toFixed(point)
        }
      }
    } else if (parseInt(temp) > 999999999999) {
      return ((parseFloat(temp) * 1.0) / 1000000000000).toFixed(point) + "万亿"
    } else if (parseInt(temp) > 99999999) {
      return ((parseFloat(temp) * 1.0) / 100000000).toFixed(point) + "亿"
    } else {
      return ((parseFloat(temp) * 1.0) / 10000).toFixed(point) + "万"
    }
  } else {
    return value + unit
  }
}


export function formatBigNumber(value: any, tofixed = 0, suffix = '') {
  if (value == 0) {
    return parseFloat(value).toFixed(tofixed) + suffix
  }

  if (value == null || value == '' || isNaN(value)) {
    return '-'
  }
  value = parseFloat(value)
  if (value >= 1000000000000 || value <= -1000000000000) {
    return (value / 1000000000000).toFixed(tofixed) + '万亿' + suffix
  }
  else if (value >= 100000000 || value <= -100000000) {
    return (value / 100000000).toFixed(tofixed) + '亿' + suffix
  }
  else if (value >= 10000 || value <= -10000) {
    return (value / 10000).toFixed(tofixed) + '万' + suffix
  }
  else {
    return value.toFixed(tofixed) + suffix
  }
}

export function formatToSub(value1: any, value2: any) {
  if (isNaN(Number(value1)) || isNaN(Number(value2))) {
    return '-';
  } else {
    return value1 - value2;
  }
}

export function formatHKBigNumber(value: any) {
  if (value == null || value == "-") {
    return value;
  }
  let temp = Number(value);
  if (temp >= 10000) {
    return (temp / 10000).toFixed(1) + "万";
  } else {
    return value;
  }
}

export function formatPoint(value: any, num: number, isPercent = false) {
  if (value == null || value == "-" || value == undefined) {
    return "-";
  }

  if (isPercent) {
    return value.toFixed(num) + '%'
  }
  return value.toFixed(num);
}

export function topBack() {
  let refer_dictionary = ["18.cn", "1234567.com.cn", "18.com.cn", "eastmoney.com"]
  let this_refer = document.referrer
  let isEM
  if (!this_refer) {
    window.location.href = "/"
  } else {
    for (let i = 0; i < refer_dictionary.length; i++) {
      if (this_refer.indexOf(refer_dictionary[i]) > -1) {
        isEM = true
        break
      } else {
        isEM = false
      }
    }
    if (isEM) {
      if (navigator.userAgent.indexOf("MSIE") >= 0 && navigator.userAgent.indexOf("Opera") < 0) {
        // IE
        if (history.length > 0) {
          window.history.go(-1)
        } else {
          window.location.href = "/"
        }
      } else {
        //非IE浏览器
        if (navigator.userAgent.indexOf("Firefox") >= 0 || navigator.userAgent.indexOf("Opera") >= 0 || navigator.userAgent.indexOf("Safari") >= 0 || navigator.userAgent.indexOf("Chrome") >= 0 || navigator.userAgent.indexOf("WebKit") >= 0) {
          if (window.history.length > 1) {
            window.history.go(-1)
          } else {
            window.location.href = "/"
          }
        } else {
          //未知的浏览器
          window.history.go(-1)
        }
      }
    } else {
      window.location.href = "/"
    }
  }
}

export function formatDateTime(value: any) {
  if (value == "-" || isNaN(value)) return value

  let date = new Date(value)
  let now = new Date()

  let diff = now.getTime() - date.getTime()
  if (formatDate(date, "yyyy-MM-dd") == formatDate(now, "yyyy-MM-dd")) {
    if (diff < 1000 * 60 * 60) {
      return Math.floor(diff / (1000 * 60)) + "分钟前"
    } else {
      return Math.floor(diff / (1000 * 60 * 60)) + "小时前"
    }
  } else return formatDate(date, "MM-dd hh:mm")
}

export function formatDate(thisdate: any, format: any) {
  if(thisdate == null || thisdate == "-" || isNaN(thisdate)){
    return "-"
  }
  thisdate = new Date(thisdate)
  let o: any = {
    "M+": thisdate.getMonth() + 1, //month
    "d+": thisdate.getDate(), //day
    "h+": thisdate.getHours(), //hour
    "m+": thisdate.getMinutes(), //minute
    "s+": thisdate.getSeconds(), //second
    "q+": Math.floor((thisdate.getMonth() + 3) / 3), //quarter
    S: thisdate.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (thisdate.getFullYear() + "").substring(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length))
    }
  }
  return format
}

export function formatNoticeDateTime(value: any) {
  if (value == "-" || isNaN(value)) return value

  let date = new Date(value)
  let now = new Date()
  if (date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate()) {
    return "今天"
  } else return formatDate(date, "MM-dd")
}

export function loadmore() {
  let env = window.location.search
  let CODE = window.quotedata.code
  let MK = window.quotedata.market

  if (env.indexOf("?env=test") > -1) {
    location.href = "/quote/stockmore_new.html?id=" + CODE + "&mk=" + MK + "&env=test"
  } else {
    location.href = "/quote/stockmore_new.html?id=" + CODE + "&mk=" + MK
  }
}

/**
 *  1	默认
    2	退市
    4	风险警示
    8	已上市新股
    16	未上市新股
    32	暂停上市
    64	融资融券
    128	港股通(沪)
    256	港股通(深)
    512	沪股通
    1024	深股通
 * @param code 
 * @returns 
 */
export function calcLogo(code: any) {
  let str: Array<string> = []
  if (code == null || code == "" || code == "-") {
    return str
  }

  if (parseInt(code) & 64) {
    str.push("融")
  }

  if (parseInt(code) & 128) {
    str.push("港股通")
  }

  if (parseInt(code) & 256) {
    if (str.indexOf("港股通") < 0) {
      str.push("港股通")
    }
  }

  if (parseInt(code) & 512) {
    str.push("沪股通")
  }

  if (parseInt(code) & 1024) {
    str.push("深股通")
  }

  return str
}

export function FormatArr(value: any, position: number, stockmore = false) {
  if (value == null || value == "-") {
    return value
  }
  if (stockmore) {
    return value.split(",")[position]
  }

  if (position == 0) {
    return value.split(",")[position].substring(0, 5)
  } else {
    return value.split(",")[position]
  }
}

export function toFix(num: any, n: number, affix = "") {
  let f = parseFloat(String(num))
  if (isNaN(f)) {
    return "-"
  }
  let f1 = Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
  if (n == 0) {
    return f1
  } else {
    let s = f1.toString()
    let rs = s.indexOf(".")
    if (rs < 0) {
      rs = s.length
      s += "."
    }
    while (s.length <= rs + n) {
      s += "0"
    }
    return s + affix
  }
}

// // 判断该股票是否为债券
export function isBond(market: number, type: number, typeEx: number) {
  // 返回值 1：深交所债券 2：深交所质押回购 3：上交所债券 4：上交所质押回购
  if (market == 0 && type == 8) {
    if (typeEx == 14) {
      return 2
    } else {
      return 1
    }
  }
  if (market == 1 && type == 4) {
    if (typeEx == 14) {
      return 4
    } else {
      return 3
    }
  }
  return false
}

export function isIOS() {
  let UA = navigator.userAgent
  let Agents = ["iPhone", "iPad", "iPod"]
  for (let i = 0; i < Agents.length; i++) {
    if (UA.indexOf(Agents[i]) > 0) {
      return true
    }
  }
  return false
}

export function gubaCodeChange(code: string) {
  let HS_CODE_HS = "1",
    HS_CODE_SS = "0",
    GG_CODE = "116",
    MG_CODE_NS = "105",
    MG_CODE_NJ = "106",
    MG_CODE_MJ = "107",
    YG_CODE_LD = "155",
    YG_CODE_LDGJ = "156",
    BK_CODE_NO = "90",
    CHOICE_ZS = "47",
    JP_CODE = "176", // 日本
    KR_CODE = "177", // 韩国 
    TW_CODE = "178" // 台湾

  switch (window.quotedata.market.toString()) {
    case YG_CODE_LD:
      return "lse" + code
    case JP_CODE:
      return "jpx" + code
    case KR_CODE:
      return "krx" + code
    case TW_CODE:
      return "twse" + code
    case YG_CODE_LDGJ:
      return "lseiob" + code
    case HS_CODE_SS:
      return "sz" + code
    case HS_CODE_HS:
      return "sh" + code
    case CHOICE_ZS:
      return "sh" + code
    case GG_CODE:
      return "hk" + code
    case BK_CODE_NO:
      return code.toLowerCase()
    case MG_CODE_MJ: //107
    case MG_CODE_NJ: //106
    case MG_CODE_NS: //105
      return "us" + code
    case "100":
      return "qqzs|" + code
    case "113":
      return "shfe" + code
    case "114":
      return "dce" + code
    case "115":
      return "czce" + code
    case "8":
      return "gzqh" + code
    case "108":
      return "nybot" + code
    case "119":
      return "forex" + code
    case "120":
      return "cnyrate" + code
    case "121":
      return "cnyforex" + code
    case "133":
      return "cnyoffs" + code
    case "122":
      return "forpm" + code
    case "118":
      return "sge" + code
    case "10":
      return "" + code
    case "111":
      return "tocom" + code
    case "112":
      return "ipe" + code
    case "102":
      return "nymex" + code
    case "142":
      return "ine" + code
  }
}

export function getStockKind(type: string, single?: string) {
  if (single == "1") {
    switch (type) {
      case "0":
        return "2"
      case "1":
        return "1"
      default:
        return ""
    }
  } else {
    switch (type) {
      case "0":
        return "02"
      case "1":
        return "01"
      default:
        return ""
    }
  }
}

export function isWeChat() {
  let isWx = false
  let browser = navigator.userAgent.toLowerCase()

  if (browser.indexOf("micromessenger") != -1 || browser.indexOf("qq/") != -1 || browser.indexOf("weibo") != -1) {
    isWx = true
  }
  return isWx
}

export function iszq(MK: number, CODE: string, _market: any) {
  if (MK == 1 && CODE.substring(0, 3) == "019") {
    return true
  }
  if (MK == 1 && CODE.substring(0, 3) == "010") {
    return true
  }
  if (MK == 1 && CODE.substring(0, 1) == "1") {
    return true
  }
  if (_market?.f107 == 1 && _market?.f182 == 14) {
    return false
  }

  if (MK == 1 && CODE.substring(0, 1) == "2") {
    return true
  }
  return false
}

//判断是否该code为指数
export function iszs(MK: number, CODE: string) {
  if (MK == 47) {
    return true
  }

  if (MK == 159 || MK == 223) {
    return true
  }

  if (CODE.substring(0, 3) == "000" && MK == 1) {
    return true
  }

  if (CODE.substring(0, 3) == "399" && MK == 0) {
    return true
  }

  if (CODE.substring(0, 3) == "395" && MK == 0) {
    return true
  }
  return false
}

export function formatUnitSpe(value: any, point: number, unit: string, isquzheng: boolean) {
  if (value == null || value == "-") {
    return value + unit;
  }
  if (isquzheng) {
    return Math.round(parseFloat(value) * 1.0 / point) + unit;
  } else {
    return (parseFloat(value) * 1.0 / point) + unit;
  }
}

export function formatUnitPk(value: any) {
  if (value == null || value == "-") {
    return "-";
  }
  return Math.round(Number(value) / 10000)
}

export function mpSort(arr: Array<any>) {
  for (let j = 0; j < arr.length - 1; j++) {
    //两两比较，如果前一个比后一个大，则交换位置。
    for (let i = 0; i < arr.length - 1 - j; i++) {
      if (arr[i] > arr[i + 1]) {
        let temp = arr[i];
        arr[i] = arr[i + 1];
        arr[i + 1] = temp;
      }
    }
  }
}

/**
 * 获取股票标识
 * @param code 
  //1	默认
  //2	退市
  //4	风险警示
  //8	已上市新股
  //16	未上市新股
  //32	暂停上市
  //64	融资融券
  //128	港股通(沪)
  //256	港股通(深)
  //512	沪股通
  //1024	深股通
 * @returns 
 */
export function getHeaderLabel(code: any) {
  let str: Array<string> = [];
  if (code == null || code == "" || code == "-") {
    return str;
  }

  if (parseInt(code) & 64) {
    str.push("融");
  }

  if (parseInt(code) & 128) {
    str.push("港股通");
  }

  if (parseInt(code) & 256) {
    if (str.indexOf("港股通") < 0) {
      str.push("港股通");
    }
  }

  if (parseInt(code) & 512) {
    str.push("沪股通");
  }

  if (parseInt(code) & 1024) {
    str.push("深股通");
  }

  return str;
}

export function getTradeStatus(value: any) {
  if (value == "-" || value == null || value == undefined) {
    return "-"
  }
  let state = ['', '开盘竞价', '交易中', '盘中休市', '收盘竞价', '已收盘', '停牌', '退市', '暂停上市', '未上市', '未开盘', '盘前', '盘后', '休市', '盘中停牌', '非交易代码', '波动性中断', '盘后交易启动', '盘后集中撮合交易', '盘后固定价格交易']
  if(window.innerWidth < 330){
    state[value] = state[value].substring(0,6)+"..."
  }
  return state[value]
}


export function numberFix(num: number, n: number) {
  let f1 = parseFloat(num.toString());
  if (isNaN(f1)) {
    return false;
  }
  let f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
  if (n == 0) {
    return f
  } else {
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + n) {
      s += '0';
    }
    return s;
  }
}

//判断用户是否为内地IP
export function checkIP() {
  //港股行情需要判断是否为内地IP 该接口访问的lt可以区分
  //0是无法判断归属地，1是中国大陆，2是非中国大陆地区
  let url = `https://push2.eastmoney.com/api/qt/stock/get?${delayparams.substring(1)}`
  let xhr = $.ajax({
    url: url,
    async: false
  });
  let data = JSON.parse(xhr.responseText)
  let isCN = data?.lt == 1 ? true : false
  cookie.set("quote_lt",data?.lt,90,".eastmoney.com")
  return isCN
}


export function FormateArrTY(value: any, position: number, sp: string) {
  if (value == null || value == "-") {
    return value;
  }

  return value.split(sp)[position];
}

export function dateTransform(value: any) {
  if (value == '-') {
    return '-'
  }

  let v = String(value)
  let y = v.slice(0, 4)
  let m = v.slice(4, 6)
  let d = v.slice(6, 8)
  return y + '-' + m + '-' + d
}

// 字符串日期转换
export function FormatStringDate(date: any) {
  let dateArr = ['日', '一', '二', '三', '四', '五', '六']
  return dateArr[new Date(date).getDay()]
}

// 获取报价交易方式
export function returnTransactionMode(val: any) {
  if (val == 1) {
    return '匹配成交'
  } else if (val == 2) {
    return '协商成交'
  } else if (val == 4) {
    return '点击成交'
  } else if (val == 8) {
    return '意向申报'
  } else if (val == 16) {
    return '询价成交'
  } else if (val == 32) {
    return '竞买成交'
  } else if (val == 64) {
    return '匹配成交大额'
  } else {
    return '-'
  }
}

// 获取报价买卖方向
export function getTradeDirection(item: any) {
  if (item == "49") {
    return "买入"
  } else if (item == "50") {
    return "卖出"
  } else if (item == "70") {
    return "出借"
  } else if (item == "71") {
    return "借入"
  } else {
    return "-"
  }
}

// 获取报价结算方式
export function getSettleMethod(item: any) {
  if (item == 0) {
    return '不指定'
  } else if (item == 103) {
    return '多边净额'
  } else if (item == 104) {
    return '逐笔全额'
  } else {
    return '-'
  }
}

// 获取报价结算周期
export function getSettlePeriod(item: any) {
  if (item == 0) {
    return 'T+0'
  } else if (item == 1) {
    return 'T+1'
  } else if (item == 2) {
    return 'T+2'
  } else if (item == 3) {
    return 'T+3'
  } else {
    return '-'
  }
}

export function dateAllTransform(v1: any, v2: any, v3: any, v4: any) {
  if (v1 == '-' && v2 == '-' && v3 == '-' && v4 == '-') {
    return '-'
  }
  let arr = [monthTrans(v1), monthTrans(v2), monthTrans(v3), monthTrans(v4)]
  let resArr = []
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] != '') {
      resArr.push(arr[i])
    }
  }
  let res = resArr.join(",")
  return res
}

export function monthTrans(value: any) {
  if (value == '-') {
    return ''
  }
  value = String(value)
  if (value.length == 3) {
    value = '0' + value
  }
  return value.slice(0, 2) + '-' + value.slice(2, 4)
}

// 获取付息方式
export function getFxfs(value: any) {
  if (value == 0) {
    return '其他'
  } else if (value == 1) {
    return '按年'
  } else if (value == 2) {
    return '半年'
  } else if (value == 3) {
    return '季度付息'
  } else if (value == 4) {
    return '到期一次性还本付息'
  } else {
    return '-'
  }
}

export function getSpecialFxfs(value: any){
  if (value.length > 6 && window.innerWidth < 350) {
    return value.substring(0,6) + '...'
  } else {
    return value
  }
}

// 获取息票品种
export function getXppz(value: any) {
  if (value == 0) {
    return '其它债券'
  } else if (value == 1) {
    return '贴现债券'
  } else if (value == 2) {
    return '付息债券'
  } else if (value == 3) {
    return '息票累积债券'
  } else {
    return '-'
  }
}

export function isSearch() {
  let ref = window.document.referrer == "" ? "no referrer" : window.document.referrer;
  //let arr = ['bing.com', 'baidu.com', 'so.com', 'google.com', 'yahoo.com', 'sohu.com', 'sogou.com'];
  let arr = ['.so.', '.360.', '.chinaso.', '.shatangju.', '.haosou.', '.210v.', '.bing.', '.soso.', '.yicha.', '.baidu.', '.sm-tc.', '.sm.', '.yangsou.', '.sogo.', '.sogou.', '.youdao.', '.1422.', '.baiducontent.', '.stock1.', '.google.', '.iwencai.', '.yahoo.'] //扩充搜索引擎，参考大数据
  return (arr.some((v) => {
    return ref.indexOf(v) >= 0
  }))
}

export function goAppAuto(market: number, code: string) {
  try {
    let sUserAgent: any = navigator.userAgent.toLowerCase();
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    if ((market == 0 || market == 1 || market == 116) && !isWeChat() && !bIsAndroid) {
      if (isSearch()) {
        // 如果是来自搜索引擎，则尝试跳转APP
        let usercollect = window.btoa(`wap.ssyq.${window.emtj_pageId}.${getCookie("st_pvi")}`)
        let options = {
          linkType: 818,
          parm: `market=${market}&stockCode=${code}`,
          keepSecond: 3,
          sharetype: `app.start.${usercollect}`,
          failHandle: '0',// IOS无法唤醒APP则回到原页面。0：5秒返回原页面，1：跳转appstore
          callback: function () {
            console.log('未安装APP')
          }
        }
        window.emawake.openApp.open(options)
      }
    }
  } catch (error) {

  }
}

export function formatCountry(value:any){
  if(value == null || value == "-"){
    return "-"
  }
  if(value.toLowerCase() == "cn"){
    return "中国"
  }else if(value.toLowerCase() == "us"){
    return "美国"
  }else{
    return "-"
  }
}

export function formatTipsDate(thisdate: any, format: any) {
  if(thisdate == null || thisdate == "-" || isNaN(thisdate)){
    return "-"
  }
  thisdate = new Date(thisdate)
  let o: any = {
    "M+": thisdate.getMonth() + 1, //month
    "d+": thisdate.getDate(), //day
    "h+": thisdate.getHours(), //hour
    "m+": thisdate.getMinutes(), //minute
    "s+": thisdate.getSeconds(), //second
    "q+": Math.floor((thisdate.getMonth() + 3) / 3), //quarter
    S: thisdate.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (thisdate.getFullYear() + "").substring(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length))
    }
  }
  return format
}

export function isBaidu(){
  if (document.referrer.indexOf("baidu.com") > -1) {
    return true
  } else {
    return false
  }
}
